import axios from 'axios';

import { getChannelToken_v1 } from 'js/library/utils/API/getChannelToken_v1';
import { uploadImage, deleteImage } from 'js/library/services/StorageManager.js';
import { b64toBlob } from 'js/library/utils/helpers';
import cfac22 from '../cfac22';

export function insertOrUpdateOrg(
  uId,
  newInfo,
  newCoverImage,
  coverImageFile,
  oldCoverImage,
  newThumbnail,
  thumbnailFile,
  oldThumbnail,
  newLogo,
  logoFile,
  oldLogo
) {
  return new Promise((resolve, reject) => {
    getChannelToken_v1(uId)
      .then((result) => {
        //console.log('RESULTADO GET CHANNEL TOKEN ===>', result);
        axios
          .post(
            cfac22('API_HOST_V1') + 'insertOrUpdateOrg',
            {
              triiboHeader: {
                apiToken: cfac22('apiToken'),
                channelGroup: cfac22('channelGroup'),
                channelName: cfac22('channelName'),
                uId: uId,
                channelTokenId: result,
                channelId: cfac22('channelId'),
                sessionId: '001',
                transactionId: '002',
              },
              orgInfo: newInfo,
            },
            {
              headers: {
                'Full-Url': window.location.href,
              },
            }
          )
          .then(async (result) => {
            //console.log('RESULTADO UPDATE ORG ===>', result);

            Promise.all([
              manageImages(newLogo, oldLogo, newInfo.logoImage, logoFile),
              manageImages(newCoverImage, oldCoverImage, newInfo.coverImage, coverImageFile),
              manageImages(newThumbnail, oldThumbnail, newInfo.thumbnail, thumbnailFile),
            ]).then(() => {
              resolve(result.data);
            });
          })
          .catch((error) => {
            //console.log('ERROR UPDATE ORG ---->', error);
            reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR GET CHANNEL TOKEN ---->', error);
        reject(error);
      });
  });
}

async function manageImages(hasImage, oldImage, newImage, newImageFile) {
  if (hasImage) {
    newImageFile = b64toBlob(newImageFile);
    await deleteImage(oldImage.split('/')[0], oldImage.split('/')[1]);
    await uploadImage(newImage.split('/')[0], newImageFile, newImage.split('/')[1]);
  }
  return true;
}
